import React from "react";
import Hero from "../components/Hero";
import Features from "../components/Features";
import AppsShowcase from "../components/AppsShowcase";
import FutureDevelopments from "../components/FutureDevelopments";

const LandingPage = () => {
  return (
    <>
      <Hero />
      <Features />
      <AppsShowcase />
      <FutureDevelopments />
    </>
  );
};

export default LandingPage;
